import { useCallback, useMemo, useState } from 'react'
import bundledNotes from '../../generated/releaseNotes.json'
import { localStorageGetJson, localStorageSetJson } from '../../utils'

export interface ReleaseNote {
    version: string
    date: string
    body: string
}

const LAST_SEEN_KEY = 'whats-new-last-seen'

interface LastSeen {
    version: string
}

export const compareVersions = (a: string, b: string) => {
    const pa = a.split('.').map(Number)
    const pb = b.split('.').map(Number)
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const diff = (pa[i] || 0) - (pb[i] || 0)
        if (diff !== 0) return diff
    }
    return 0
}

export function useReleaseNotes() {
    const notes = bundledNotes as ReleaseNote[]
    const latestVersion = notes[0]?.version
    const [lastSeen, setLastSeen] = useState(() => localStorageGetJson<LastSeen>(LAST_SEEN_KEY)?.version)

    const hasUnread = useMemo(() => {
        if (!latestVersion) return false
        if (!lastSeen) return true
        return compareVersions(latestVersion, lastSeen) > 0
    }, [latestVersion, lastSeen])

    const markSeen = useCallback(() => {
        if (!latestVersion) return
        localStorageSetJson<LastSeen>(LAST_SEEN_KEY, { version: latestVersion })
        setLastSeen(latestVersion)
    }, [latestVersion])

    return { notes, hasUnread, markSeen }
}
